<teleport to="body">
  <div class="modal fade" id="product_promo_code_manager_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <div>
            <h5 class="modal-title text-xxs fw-500 text-white">Product Promo Codes</h5>
          </div>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset_form"
          ></button>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="modal-title text-xxs fw-500 text-dark">{{ selected_product?.name || 'Selected product' }} promo codes</h5>
            </div>
            <button
              class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm"
              type="button"
              @click="open_product_promo_form_modal()"
            >
              Create Promo Code
            </button>
          </div>
          <p v-if="promo_errors.product" class="text-danger text-xxs">{{ promo_errors.product }}</p>

          <div v-if="is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mb-0 text-muted text-xxs">Loading Promo Codes...</p>
          </div>

          <div v-else-if="product_promo_codes.length" class="table-responsive">
            <table class="table table-hover align-middle mb-0 border">
              <thead class="table-light">
                <tr class="text-xxs text-uppercase text-secondary">
                  <th scope="col">Promo Code</th>
                  <th scope="col">Type</th>
                  <th scope="col">Discount</th>
                  <th scope="col">Min Order</th>
                  <th scope="col">Usage</th>
                  <th scope="col">Status</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in product_promo_codes" :key="item.id">
                  <td class="fw-bold text-dark text-xxs">{{ get_promo_code_name(item) }}</td>
                  <td class="text-xxs">
                    <span class="text-xxs">
                      {{ item?.promo_code?.promo_code_type?.name || 'fixed' }}
                    </span>
                  </td>
                  <td class="text-xxs fw-500 text-primary">
                    <span v-if="item?.promo_code?.promo_code_type?.name === 'percentage'">
                      {{ item?.promo_code?.discount_amount || 0 }}%
                    </span>
                    <span v-else>
                      R{{ item?.promo_code?.discount_amount || 0 }}
                    </span>
                  </td>
                  <td class="text-xxs">
                    R{{ format_amount(item?.minimum_order_amount || 0) }}
                  </td>
                  <td class="text-xxs">
                    <span class="text-dark" v-if="item.has_usage_limit">
                      {{ item.usage_count }} / {{ item.usage_limit }}
                    </span>
                    <span v-else class="badge bg-light text-dark">
                      {{ item.usage_count }} / <i class="bi bi-infinity fw-500"></i>
                    </span>
                  </td>
                  <td class="text-center product-promo-status-cell">
                    <div class="form-check form-switch d-inline-flex align-items-center justify-content-center product-promo-status-switch">
                      <input
                        class="form-check-input product-promo-status-input"
                        type="checkbox"
                        role="switch"
                        :id="'product-promo-switch-' + item.id"
                        :checked="item.is_active"
                        @change="toggle_product_promo_status(item)"
                      >
                    </div>
                  </td>
                  <td class="text-xxs">
                    {{ format_date(item.valid_start_date) }}
                  </td>
                  <td class="text-xxs text-danger">
                    {{ format_date(item.valid_end_date) }}
                  </td>
                  <td class="text-end">
                    <span class="position-relative d-inline-block">
                      <button
                        class="btn btn-sm text-dark me-2"
                        title="Share Promo Code"
                        type="button"
                        @click.stop="toggle_share_menu(item.id, $event)"
                      >
                        <i class="bi bi-share"></i>
                      </button>
                      <div
                        v-if="is_share_menu_open(item.id)"
                        class="incident-share-popover shadow-sm promo-code-share-popover"
                        :style="get_share_menu_style(item.id)"
                        @click.stop
                      >
                        <button type="button" class="incident-share-item" @click="copy_promo_code(item)">
                          <i class="bi bi-link-45deg text-primary"></i>
                          <span>Copy code</span>
                        </button>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('facebook', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-facebook text-primary"></i>
                          <span>Facebook</span>
                        </a>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('whatsapp', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-whatsapp text-success"></i>
                          <span>WhatsApp</span>
                        </a>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('email', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-envelope text-secondary"></i>
                          <span>Email</span>
                        </a>
                      </div>
                    </span>
                    <button
                      class="btn btn-sm text-primary me-2"
                      title="Edit Product Promo Code"
                      @click.stop="open_edit_product_promo_form_modal(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-sm text-danger" title="Remove From Product" @click.stop="delete_product_promo_code(item)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else>
            <div class="text-center py-4 text-muted text-xxs">
              No promo codes linked yet.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="product_sale_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
      <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
        <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
          <button
            type="button"
            class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="fas fa-times fs-6"></i>
          </button>
        </div>
        <form @submit.prevent="submitProductSale()">
          <div class="modal-body modal-body-scroll">
             <div class="row">
             <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Type <span class="text-danger">*</span></label>
                <select class="form-select rounded-3 text-xxs" v-model="sale_discount_type">
                  <option v-for="option in discount_types" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <p v-if="promo_errors.sale_discount_type" class="text-danger text-xxs">{{ promo_errors.sale_discount_type }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Value <span class="text-danger">*</span></label>
                <input
                  type="number"
                  class="form-control rounded text-xxs"
                  v-model="sale_discount_value"
                  placeholder="Enter discount value"
                  min="0"
                  step="0.01"
                />
                <p v-if="promo_errors.sale_discount_value" class="text-danger text-xxs">{{ promo_errors.sale_discount_value }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="sale_start_date" class="form-label text-xxs fw-500">
                  Sale start date <span class="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  class="form-control rounded text-xxs input-dark"
                  id="sale_start_date"
                  v-model="sale_start_date"
                  :min="min_datetime"
                  :disabled="is_event_dates_locked"
                >
                <p v-if="promo_errors.sale_start_date" class="text-danger text-xxs mt-1 mb-0">
                  {{ promo_errors.sale_start_date }}
                </p>
              </div>

              <div class="col-12 col-md-6 mb-3">
                <label for="sale_end_date" class="form-label text-xxs fw-500">
                  Sale end date <span class="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  class="form-control rounded text-xxs input-dark"
                  id="sale_end_date"
                  v-model="sale_end_date"
                  :min="min_datetime"
                  :disabled="is_event_dates_locked"
                >
                <p v-if="promo_errors.sale_end_date" class="text-danger text-xxs mt-1 mb-0">
                  {{ promo_errors.sale_end_date }}
                </p>
              </div>
              <div class="col-12 mb-3">
                <div class="form-check pt-1">
                  <input type="checkbox" class="form-check-input" id="product_sale_is_active" v-model="sale_is_active">
                  <label class="form-check-label text-xxs fw-500" for="product_sale_is_active">Active</label>
                </div>
              </div>
            </div>
            <div v-if="sale_preview_products.length" class="pt-2">
              <hr class="my-2">
              <div
                v-for="item in sale_preview_products"
                :key="`sale-preview-${item.id}`"
                class="d-flex justify-content-between align-items-start gap-3 py-1"
              >
                <div class="text-xxs text-dark flex-grow-1">
                  {{ item.name }}
                </div>
                <div class="text-xxs text-end text-nowrap">
                  <span class="text-muted text-decoration-line-through me-1">
                    R{{ format_amount(item.original_price) }}
                  </span>
                  <span class="text-dark">
                    R{{ format_amount(item.discounted_price) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0">
            <button type="submit" class="btn btn-primary text-xxs rounded cursor-pointer" :disabled="!is_valid_event">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="product_promo_code_form_modal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">
            {{ is_catalogue_promo ? 'Create Catalogue Promo Code' : (is_editing_product_promo ? 'Edit Promo Code' : 'Create Promo Code') }}
          </h5>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close_child_modal"
          ></button>  
        </div>
        <div class="modal-body">
          <form @submit.prevent="submit_form" novalidate>
            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Promo Code</label>
              <input
                type="text"
                class="form-control rounded text-xxs"
                v-model="promo_code_name"
                placeholder="Leave blank to auto-generate"
              />
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Type <span class="text-danger">*</span></label>
                <select class="form-select rounded-3 text-xxs" v-model="discount_type">
                  <option v-for="option in discount_types" :key="option.value" :value="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <p v-if="promo_errors.discount_type" class="text-danger text-xxs">{{ promo_errors.discount_type }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Discount Value <span class="text-danger">*</span></label>
                <input
                  type="number"
                  class="form-control rounded text-xxs"
                  v-model.number="discount_value"
                  min="0"
                  step="0.01"
                  placeholder="Discount value"
                />
                <p v-if="promo_errors.discount_value" class="text-danger text-xxs">{{ promo_errors.discount_value }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Valid start date</label>
                <input type="datetime-local" class="form-control rounded text-xxs" v-model="start_date" :min="min_start_date"/>
                <p v-if="promo_errors.start_date" class="text-danger text-xxs">{{ promo_errors.start_date }}</p>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Valid end date</label>
                <input type="datetime-local" class="form-control rounded text-xxs" v-model="end_date" :min="min_end_date"/>
                <p v-if="promo_errors.end_date" class="text-danger text-xxs">{{ promo_errors.end_date }}</p>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Usage Limit</label>
                <input type="number" class="form-control rounded text-xxs" v-model.number="usage_limit" min="0" placeholder="e.g. 100"/>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label text-xxs fw-500">Minimum Order Amount</label>
                <input
                  type="number"
                  class="form-control rounded text-xxs"
                  v-model.number="minimum_order_amount"
                  min="0"
                  step="0.01"
                  placeholder="e.g. 500"
                />
                <p v-if="promo_errors.minimum_order_amount" class="text-danger text-xxs">{{ promo_errors.minimum_order_amount }}</p>
              </div>
            </div>

            <div class="row align-items-end">
              <div class="col-md-6 mb-3">
                <div class="form-check pb-2">
                  <input type="checkbox" class="form-check-input" id="product_promo_is_active" v-model="is_active">
                  <label class="form-check-label text-xxs fw-500" for="product_promo_is_active">Active</label>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4">
              <button
                type="submit"
                class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm"
                :disabled="isLoading"
                @click.stop
              >
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ is_catalogue_promo ? 'Create For Catalogue' : (is_editing_product_promo ? 'Update' : 'Create') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div
    class="modal fade"
    id="catalogue_promo_code_manager_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content rounded shadow scrollable-container">
        <div class="modal-header bg-primary position-relative">
          <h5 class="modal-title text-xxs fw-500 text-white">
            Catalogue Promo Codes
          </h5>

          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="reset_form"
          ></button>
        </div>

        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="modal-title text-xxs fw-500 text-dark mb-0">
              All Catalogue Promo Codes
            </h5>

            <button
              class="btn btn-primary btn-sm btn-info text-xxs text-white rounded shadow-sm"
              type="button"
              @click="open_catalogue_promo_code_form_modal"
            >
              Catalogue Promo Code
            </button>
          </div>

          <div v-if="is_loading" class="text-center py-5 w-100">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mb-0 text-muted text-xxs">Loading Promo Codes...</p>
          </div>

          <div v-else-if="catalogue_promo_codes.length" class="table-responsive">
            <table class="table table-hover align-middle mb-0 border">
              <thead class="table-light">
                <tr class="text-xxs text-uppercase text-secondary">
                  <th>Promo Code</th>
                  <th>Type</th>
                  <th>Discount</th>
                  <th>Min Order</th>
                  <th>Usage</th>
                  <th>Status</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in catalogue_promo_codes" :key="item.id">
                  <td class="fw-bold text-dark text-xxs">
                    {{ get_promo_code_name(item) }}
                  </td>

                  <td class="text-xxs">
                    {{ item?.promo_code?.promo_code_type?.name || 'fixed' }}
                  </td>

                  <td class="text-xxs fw-500 text-primary">
                    <span v-if="item?.promo_code?.promo_code_type?.name === 'percentage'">
                      {{ item?.promo_code?.discount_amount || 0 }}%
                    </span>
                    <span v-else>
                      R{{ item?.promo_code?.discount_amount || 0 }}
                    </span>
                  </td>

                  <td class="text-xxs">
                    R{{ format_amount(item?.minimum_order_amount || 0) }}
                  </td>

                  <td class="text-xxs">
                    <span v-if="item.has_usage_limit">
                      {{ item.usage_count }} / {{ item.usage_limit }}
                    </span>
                    <span v-else class="badge bg-light text-dark">
                      {{ item.usage_count }} /
                      <i class="bi bi-infinity fw-500"></i>
                    </span>
                  </td>

                  <td class="text-center">
                    <div class="form-check form-switch d-inline-flex">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        :checked="item.is_active"
                        @change="toggle_product_promo_status(item)"
                      >
                    </div>
                  </td>

                  <td class="text-xxs">
                    {{ format_date(item.valid_start_date) }}
                  </td>

                  <td class="text-xxs text-danger">
                    {{ format_date(item.valid_end_date) }}
                  </td>

                  <td class="text-end">
                    <span class="position-relative d-inline-block">
                      <button
                        class="btn btn-sm text-dark me-2"
                        title="Share Catalogue Promo Code"
                        type="button"
                        @click.stop="toggle_share_menu(item.id, $event)"
                      >
                        <i class="bi bi-share"></i>
                      </button>
                      <div
                        v-if="is_share_menu_open(item.id)"
                        class="incident-share-popover shadow-sm promo-code-share-popover"
                        :style="get_share_menu_style(item.id)"
                        @click.stop
                      >
                        <button type="button" class="incident-share-item" @click="copy_promo_code(item)">
                          <i class="bi bi-link-45deg text-primary"></i>
                          <span>Copy code</span>
                        </button>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('facebook', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-facebook text-primary"></i>
                          <span>Facebook</span>
                        </a>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('whatsapp', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-whatsapp text-success"></i>
                          <span>WhatsApp</span>
                        </a>
                        <a class="incident-share-item" target="_blank" :href="get_promo_share_url('email', item)" @click="close_share_menu(item.id)">
                          <i class="bi bi-envelope text-secondary"></i>
                          <span>Email</span>
                        </a>
                      </div>
                    </span>
                    <button
                      class="btn btn-sm text-primary me-2"
                      title="Edit Catalogue Promo Code"
                      @click.stop="open_edit_catalogue_promo_form_modal(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>

                    <button
                      class="btn btn-sm text-danger"
                      title="Delete Catalogue Promo Code"
                      @click.stop="delete_product_promo_code(item)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else class="text-center py-4 text-muted text-xxs">
            No catalogue promo codes created yet.
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
